// extracted by mini-css-extract-plugin
export default {"button":"Fl-z","reviewSort":"Gl-z"};